var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-lowercase",attrs:{"color":_vm.textColor,"tag":"button","text":"","small":"","rounded":""},domProps:{"textContent":_vm._s(_vm.text)},on:{"click":function($event){return _vm.pushLink()}}})}
var staticRenderFns = []

export { render, staticRenderFns }